/**
 * ZoomOutIcon/index.js
 * desc: zoom-out icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ZoomOutIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="zoom-out icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.zoomOut.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.75 0C13.5825 0 17.5 3.91751 17.5 8.75C17.5 10.7105 16.8552 12.5204 15.7662 13.9792L20 18.2131L18.2131 20L13.9793 15.7662C12.5204 16.8552 10.7105 17.5 8.75 17.5C3.91751 17.5 0 13.5825 0 8.75C0 3.91751 3.91751 0 8.75 0Z" />
            <path fillRule="evenodd" clipRule="evenodd" d="M15.0002 8.76379C15.0002 12.2081 12.2081 15.0002 8.76379 15.0002C5.3195 15.0002 2.52734 12.2081 2.52734 8.76379C2.52734 5.3195 5.3195 2.52734 8.76379 2.52734C12.2081 2.52734 15.0002 5.3195 15.0002 8.76379ZM12.5002 10.0002V7.50024H5.00025V10.0002H12.5002Z" fill="white"/>
        </svg>
    </IconButton>
);


export default ZoomOutIcon;
